export default function convertStringToSlug(str = '') {
  return str.trim().split(' ').join('-').toLowerCase();
}
